import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'year-currency-input',
    templateUrl: './year-currency-input.component.html',
    styleUrls: ['./year-currency-input.component.scss'],
})
export class YearCurrencyInputComponent {
    @Input() yearLabel: string = '';
    @Input() currency: string = '';
    @Input() showCurrency: boolean = false;
    @Input() alignEnd: boolean = true;

    @Output() currencySave = new EventEmitter<string>();

    isEditing: boolean = false;
    currentEditingValue: string = '';

    startEditing(event: MouseEvent): void {
        event.stopPropagation();
        this.currentEditingValue = this.currency;
        this.isEditing = true;
    }

    save(value: string): void {
        this.currencySave.emit(value.trim());
        this.isEditing = false;
    }

    onBlur(event: FocusEvent): void {
        this.save((event.target as HTMLInputElement).value);
    }

    onEnter(event: KeyboardEvent): void {
        (event.target as HTMLInputElement).blur();
    }

    onEscape(): void {
        this.isEditing = false;
    }
}
